export const extractedCategories = (labels: Array<{ label: string }>) => {
  return labels?.map((labelObj) => labelObj.label);
};
